// extracted by mini-css-extract-plugin
export default {"title":"_1263bf4754","inner_title":"_9ef31d2014","charge_btn":"_1d1f717bbb"};